const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReserve(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5264_131920",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#797C80",
    style: {
      fill: "#797C80",
      fill: "color(display-p3 0.8510 0.8510 0.8510)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5264_131920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 5.33301H12.6667V3.99967H3.33333V5.33301ZM3.33333 14.6663C2.96667 14.6663 2.65278 14.5358 2.39167 14.2747C2.13056 14.0136 2 13.6997 2 13.333V3.99967C2 3.63301 2.13056 3.31912 2.39167 3.05801C2.65278 2.7969 2.96667 2.66634 3.33333 2.66634H4V1.33301H5.33333V2.66634H10.6667V1.33301H12V2.66634H12.6667C13.0333 2.66634 13.3472 2.7969 13.6083 3.05801C13.8694 3.31912 14 3.63301 14 3.99967V7.78301C13.7889 7.68301 13.5722 7.59967 13.35 7.53301C13.1278 7.46634 12.9 7.41634 12.6667 7.38301V6.66634H3.33333V13.333H7.53333C7.61111 13.5775 7.70278 13.8108 7.80833 14.033C7.91389 14.2552 8.03889 14.4663 8.18333 14.6663H3.33333ZM12 15.333C11.0778 15.333 10.2917 15.008 9.64167 14.358C8.99167 13.708 8.66667 12.9219 8.66667 11.9997C8.66667 11.0775 8.99167 10.2913 9.64167 9.64134C10.2917 8.99134 11.0778 8.66634 12 8.66634C12.9222 8.66634 13.7083 8.99134 14.3583 9.64134C15.0083 10.2913 15.3333 11.0775 15.3333 11.9997C15.3333 12.9219 15.0083 13.708 14.3583 14.358C13.7083 15.008 12.9222 15.333 12 15.333ZM13.1167 13.583L13.5833 13.1163L12.3333 11.8663V9.99967H11.6667V12.133L13.1167 13.583Z",
    fill: "#797C80",
    style: {
      fill: "#797C80",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10.9997C5.53333 10.9997 5.13889 10.8386 4.81667 10.5163C4.49444 10.1941 4.33333 9.79967 4.33333 9.33301C4.33333 8.86634 4.49444 8.4719 4.81667 8.14967C5.13889 7.82745 5.53333 7.66634 6 7.66634C6.46667 7.66634 6.86111 7.82745 7.18333 8.14967C7.50556 8.4719 7.66667 8.86634 7.66667 9.33301C7.66667 9.79967 7.50556 10.1941 7.18333 10.5163C6.86111 10.8386 6.46667 10.9997 6 10.9997Z",
    fill: "#797C80",
    style: {
      fill: "#797C80",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReserve);
export default __webpack_public_path__ + "static/media/reserve.003db0f8729ee4df8fb62ecadc0cb439.svg";
export { ForwardRef as ReactComponent };